import { isUndefined } from 'lodash-es';
import * as t from 'io-ts';

import type { RichMultiSelectDefinition } from 'header/types';

import { define, createSpecSettingsInterface } from './_common';

export interface DimensionValuesSettingDefinition extends RichMultiSelectDefinition {
    key: 'DIMENSION_VALUES';
}

const DEFAULT_DIMENSION_VALUES: string[] = [];

const definition: DimensionValuesSettingDefinition = {
    key: 'DIMENSION_VALUES',
    type: 'RichMultiSelect',
    label: 'Dimension values',
    value: DEFAULT_DIMENSION_VALUES,
    options: [],
    scope: 'designer',
    lazy: 'uninitialized',
};

const specSettingsInterface = createSpecSettingsInterface(definition, t.array(t.string));

export const codec = specSettingsInterface.input;

export const DimensionValuesSettingDefinition = define({
    key: 'DIMENSION_VALUES',
    label: 'DimensionValues',
    definition,
    fromSetting: settings => {
        if (isUndefined(settings.internalKey)) return undefined;

        if (isUndefined(settings.dimensionValues)) return [];

        return specSettingsInterface.extractValue(settings.dimensionValues);
    },
    createDefinitionWithOpts: (opts = {}) => ({ ...definition, ...opts }),
    createDefinitionFromSpec: settings => {
        if (isUndefined(settings.internalKey)) return undefined;

        return specSettingsInterface.createDefinitionWithSettings(
            settings.dimensionValues || DEFAULT_DIMENSION_VALUES,
        );
    },

    applySettingDependency: ({ diff }) => {
        const internalKeyChanged = !!diff.INTERNAL_KEY && !!diff.INTERNAL_KEY.previous;

        return internalKeyChanged ? { value: [] } : undefined;
    },
});
